import styled from "@emotion/styled";
import { SetInterviewQuestionsTypeAction } from "../../redux/actions/InterviewQuestionsActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import SuggestionRow from "../../shared/components/SuggestionRow";
import InterviewQuestionsType, { textForInterviewQuestionsType } from "../../shared/enums/InterviewQuestionsType";

const StyledRow = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    gap: '15px',
}));


const InterviewQuestionsTypeSelection = () => {
    const savedJobs = useAppSelector(store => store.savedJobsState.jobsArray);
    const dispatch = useAppDispatch();

    const onTypeOfInterviewQuestionsSelected = (type: InterviewQuestionsType) => {
        dispatch(SetInterviewQuestionsTypeAction(type));
    }

    return (
        <StyledRow>
            {Object.values(InterviewQuestionsType).map((type, index) => {
                if (type === InterviewQuestionsType.job && savedJobs.length === 0) return undefined;
                return <SuggestionRow key={index} title={textForInterviewQuestionsType(type)} onClick={() => onTypeOfInterviewQuestionsSelected(type)} />
            })}
        </StyledRow>
    )
}

export default InterviewQuestionsTypeSelection;